/* eslint-disable prettier/prettier */
import React from "react";

const Project = ({ isActive }: any) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.0966 7.45099C12.5987 7.45099 13.0057 7.04398 13.0057 6.5419C13.0057 6.03983 12.5987 5.63281 12.0966 5.63281C11.5945 5.63281 11.1875 6.03983 11.1875 6.5419C11.1875 7.04398 11.5945 7.45099 12.0966 7.45099Z"
      fill={isActive ? "#fff" : "#1A1B1B"}
    />
    <path
      d="M6.64062 16.549H17.5497V18.3672H6.64062V16.549ZM10.277 11.849L12.8152 14.389L16.3897 10.8117L17.5497 12.0036V8.36719H13.9134L15.1043 9.52628L12.8143 11.8163L10.277 9.27628L6.64062 12.9126L7.92608 14.1981L10.277 11.849Z"
      fill={isActive ? "#fff" : "#1A1B1B"}
    />
    <path
      d="M18.4545 3.81862H15.4564C15.3671 3.6842 15.27 3.55519 15.1655 3.43225L15.1564 3.42134C14.4884 2.64339 13.5487 2.14978 12.5291 2.04134C12.2396 1.98622 11.9422 1.98622 11.6527 2.04134C10.6331 2.14978 9.69339 2.64339 9.02545 3.42134L9.01636 3.43225C8.91188 3.55489 8.81474 3.6836 8.72545 3.81771V3.81862H5.72727C5.00418 3.81934 4.3109 4.10691 3.7996 4.61821C3.28829 5.12952 3.00072 5.82279 3 6.54589V19.2732C3.00072 19.9963 3.28829 20.6895 3.7996 21.2008C4.3109 21.7121 5.00418 21.9997 5.72727 22.0004H18.4545C19.1776 21.9997 19.8709 21.7121 20.3822 21.2008C20.8935 20.6895 21.1811 19.9963 21.1818 19.2732V6.54589C21.1811 5.82279 20.8935 5.12952 20.3822 4.61821C19.8709 4.10691 19.1776 3.81934 18.4545 3.81862ZM19.3636 19.2732C19.3636 19.5143 19.2679 19.7455 19.0974 19.916C18.9269 20.0865 18.6957 20.1823 18.4545 20.1823H5.72727C5.48624 20.182 5.25515 20.0862 5.08471 19.9157C4.91428 19.7453 4.81842 19.5142 4.81818 19.2732V6.54589C4.81842 6.30486 4.91428 6.07377 5.08471 5.90333C5.25515 5.73289 5.48624 5.63704 5.72727 5.6368H9.86364C9.96796 5.12303 10.2467 4.66113 10.6526 4.32935C11.0585 3.99758 11.5667 3.81634 12.0909 3.81634C12.6152 3.81634 13.1233 3.99758 13.5292 4.32935C13.9351 4.66113 14.2139 5.12303 14.3182 5.6368H18.4545C18.6956 5.63704 18.9267 5.73289 19.0971 5.90333C19.2675 6.07377 19.3634 6.30486 19.3636 6.54589V19.2732Z"
      fill={isActive ? "#fff" : "#1A1B1B"}
    />
  </svg>
);

export default Project;
